export * from './Tabs';

export { Item as TabItem } from '@react-stately/collections';
